import React, { type FC } from 'react';

import { Flex, Text } from '@adsk/alloy-react-box';
import { IconButton } from '@adsk/alloy-react-button';
import {
  ChevronLeftIcon,
  ChevronRightIcon,
  MinusIcon,
  PlusIcon,
} from '@adsk/alloy-react-icon';
import theme from '@adsk/alloy-react-theme';

type AttachmentsViewerToolbarProps = {
  onNext: () => void;
  onPrevious: () => void;
  currentIndex: number;
  totalAttachments: number;
  zoomIn: () => void;
  zoomOut: () => void;
  currentZoomLevel: number;
  allowZoom: boolean;
};

const AttachmentsViewerToolbar: FC<AttachmentsViewerToolbarProps> = ({
  onNext,
  onPrevious,
  currentIndex,
  totalAttachments,
  zoomIn,
  zoomOut,
  currentZoomLevel,
  allowZoom,
}) => {
  return (
    <Flex
      width="300px"
      borderRadius="8px"
      backgroundColor="black"
      padding="8px 16px"
      alignItems="center"
      justifyContent="space-between"
      position="fixed"
      bottom="24px"
      style={{ color: theme.colors.white }}
    >
      <Flex alignItems="center">
        <IconButton
          onClick={onPrevious}
          data-testid="AttachmentsViewerToolbarPrevious"
        >
          <ChevronLeftIcon color={theme.colors.white} />
        </IconButton>
        <Text padding="0 8px">
          {currentIndex} of {totalAttachments}
        </Text>
        <IconButton onClick={onNext} data-testid="AttachmentsViewerToolbarNext">
          <ChevronRightIcon color={theme.colors.white} />
        </IconButton>
      </Flex>
      <Flex alignItems="center">
        <IconButton
          disabled={!allowZoom}
          onClick={zoomOut}
          data-testid="AttachmentsViewerToolbarZoomOut"
        >
          <MinusIcon
            color={allowZoom ? theme.colors.white : theme.colors.charcoal500}
          />
        </IconButton>
        <Text
          padding="0 8px"
          style={{
            color: allowZoom ? theme.colors.white : theme.colors.charcoal500,
          }}
        >
          {currentZoomLevel}%
        </Text>
        <IconButton
          disabled={!allowZoom}
          onClick={zoomIn}
          data-testid="AttachmentsViewerToolbarZoomIn"
        >
          <PlusIcon
            color={allowZoom ? theme.colors.white : theme.colors.charcoal500}
          />
        </IconButton>
      </Flex>
    </Flex>
  );
};

export default AttachmentsViewerToolbar;
